import Star from './Star.jsx';

export default Star;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/StarRating/Star/index.js